import AlignHorizontalCenterIcon from '@mui/icons-material/AlignHorizontalCenter';
import AlignHorizontalLeftIcon from '@mui/icons-material/AlignHorizontalLeft';
import AlignHorizontalRightIcon from '@mui/icons-material/AlignHorizontalRight';
import React from 'react';

export const horizontalAlignmentOptions = [
	{ value: 'left', label: <AlignHorizontalLeftIcon /> },
	{ value: 'center', label: <AlignHorizontalCenterIcon /> },
	{ value: 'right', label: <AlignHorizontalRightIcon /> }
];

export const TypographyVariantsOptions = [
	'h1',
	'h2',
	'h3',
	'subtitle1',
	'subtitle2',
	'body1',
	'body2'
];

export const VariantsOptions = ['primary', 'secondary'];
